// Source of truth: backend/config/searchConfig.js → contact section
// Mirror any changes made there into this file.
export const WHATSAPP_NUMBER = '27843655118'

// All outbound emails go to every address in this list (comma-joined for mailto)
const CONTACT_EMAILS = [
  'john@glossarium.co.za',
  'sanette@actuminnovations.co.za',
]
export const CONTACT_EMAIL = CONTACT_EMAILS.join(';')

function fmt(val) {
  return parseFloat(val.toFixed(2))
}

function buildContactLine(user) {
  const parts = []
  if (user?.displayName) parts.push(`Name: ${user.displayName}`)
  if (user?.companyName && user.companyName !== user.displayName) parts.push(`Company: ${user.companyName}`)
  if (user?.email) parts.push(`Email: ${user.email}`)
  if (user?.cellNumber) parts.push(`Cell: ${user.cellNumber}`)
  return parts.length ? `\n\n--- Sender Details ---\n${parts.join('\n')}` : ''
}

function buildMessage(bestFit, searchedDimensions, user) {
  if (bestFit) {
    const caseStr = `${fmt(bestFit.length)} × ${fmt(bestFit.width)} × ${fmt(bestFit.depth)} cm`
    const searchStr = searchedDimensions
      ? `${fmt(searchedDimensions.length)} × ${fmt(searchedDimensions.width)} × ${fmt(searchedDimensions.depth)} cm`
      : null
    return (
      `Hi! I used the Case Sizing Engine and my best overall fit is the ${bestFit.model}` +
      ` (internal dimensions: ${caseStr}).` +
      (searchStr ? ` My item dimensions were: ${searchStr}.` : '') +
      ` I'd like to find out more about this case.` +
      buildContactLine(user)
    )
  }
  return `Hi! I'd like to get in touch regarding a protective case. Can you help me find the right one?` + buildContactLine(user)
}

export function buildWhatsAppURL(bestFit, searchedDimensions, user) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(buildMessage(bestFit, searchedDimensions, user))}`
}

export function buildMailtoURL(bestFit, searchedDimensions, user) {
  let subject
  if (bestFit) {
    subject = `Case Enquiry – ${bestFit.model} - Case Sizing Engine`
  } else if (searchedDimensions) {
    const { length, width, depth } = searchedDimensions
    subject = `Case Sizing Enquiry – No Match Found: ${length} × ${width} × ${depth} cm`
  } else {
    subject = 'Case Enquiry from Case Sizing Engine'
  }
  return `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(buildMessage(bestFit, searchedDimensions, user))}`
}

// Auth page (pre-login) contact buttons
// Mirror: backend/config/searchConfig.js → contact.authPageMessage / authPageEmailSubject
const AUTH_PAGE_MESSAGE = `Hi! I'm interested in using the Case Sizing Engine to find the right protective case for my needs. Please could you assist me with access.`
const AUTH_PAGE_SUBJECT = `Case Sizing Engine – Access Request`

export function buildAuthWhatsAppURL() {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(AUTH_PAGE_MESSAGE)}`
}

export function buildAuthMailtoURL() {
  return `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(AUTH_PAGE_SUBJECT)}&body=${encodeURIComponent(AUTH_PAGE_MESSAGE)}`
}
